export const cnpjMask = (valor) => {
  const cleaned = valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

  return cleaned
    .replace(/^(.{2})(.)/,        '$1.$2')   
    .replace(/^(.{6})(.)/,        '$1.$2')   
    .replace(/^(.{10})(.)/,       '$1/$2')   
    .replace(/^(.{15})(.{1,2})$/, '$1-$2')  
    .substring(0, 18); 
};